module.exports = __webpack_public_path__ + "static/media/TC.6cee7489.svg";